/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { FC, Suspense } from "react";

import RouteFallbackLoader from "~/components/loader/RouteFallbackLoader";
import { ComponentBaseProps } from "~/types";

const AsyncPageRoute: FC<ComponentBaseProps> = ({ children }) => {
  return <Suspense fallback={<RouteFallbackLoader />}>{children}</Suspense>;
};

export default AsyncPageRoute;
